import { render, staticRenderFns } from "./Ageing.vue?vue&type=template&id=4e68c447"
import script from "./Ageing.vue?vue&type=script&lang=js"
export * from "./Ageing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports